import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

const CareSheetPreview = ({
	link
}) => {
	return (
		<a href={link} target="_blank" className="preview">{I18n.t('PREVIEW_CARE_SHEET')}</a>
	);
};

CareSheetPreview.propTypes = {
	link: PropTypes.string.isRequired
};

export default CareSheetPreview;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/CareSheetPreview.js
 **/